export default __webpack_public_path__ + "static/media/Vest of the Hell Walker (nm).73584005.jpg";